import { pathOr } from 'ramda';
import * as React from 'react';

import { ERoomType } from '../../../types/jsonQuery';
import { useContext } from '../../../utils/useContext';
import { RoomType } from '../../../components/filters/RoomType';

export const RoomTypeContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const roomType = pathOr<ERoomType[]>([], ['room', 'value'], jsonQuery);

  const handleChange = React.useCallback(
    (roomType: ERoomType[]) => {
      onChange({ action: 'setRoomTypes', arguments: [roomType] });
    },
    [onChange],
  );

  return <RoomType value={roomType} onChange={handleChange} />;
};
